import { render, staticRenderFns } from "./EmployeeMasterEdit.vue?vue&type=template&id=db2db3a4&scoped=true"
import script from "./EmployeeMasterEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeMasterEdit.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeMasterEdit.vue?vue&type=style&index=0&id=db2db3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2db3a4",
  null
  
)

export default component.exports